import { Module, VuexModule, Mutation } from 'vuex-module-decorators'
import { ProductPriceViewQuery } from '~/graphql/types'

@Module({
  name: 'product-price',
  stateFactory: true,
  namespaced: true,
})
export default class ProductPrice extends VuexModule {
  fetchStarted = false
  loading = true
  _items: ProductPriceViewQuery['product_price_view'] = []

  get items() {
    return this._items
  }

  @Mutation
  setFetchStarted(fetchStarted) {
    this.fetchStarted = fetchStarted
  }

  @Mutation
  setLoading(loading) {
    this.loading = loading
  }

  @Mutation
  setItems(items) {
    this._items = items
  }
}
